import React from 'react';
import { setIFrameHeightBasedOnVideoType } from 'components/newAccountSteps/profileSteps/profileStep3/videocall/videocallHelper';

export const VideoIframe = ({ type, videoUrl }) => {
    return (
        <iframe
            id="videoIframe"
            title="videoIframe"
            src={videoUrl}
            height={setIFrameHeightBasedOnVideoType(type)}
            allow="camera; microphone;"
        />
    );
};
